import { Types } from '~/graphql';
import { EventOptions } from '~/shared/formOptions';
import { formatEnum } from './formatEnum';

export const formatCurrency = (id: Types.Currency) =>
    formatEnum(id, { options: EventOptions.currency, messages: {} });
